<template>
  <navBack></navBack>
  <div>
    <t-tabs v-model="activeIndex" @change="onTabsChange" class="custom-tabs">
      <t-tab-panel label="次卡" value="0">
        <block v-for="(item, index) in cardList" :key="item._id">
          <t-cell 
            @click="choseThisCard(item, 1, index)"
            @longpress="handleLongPress(item, 1, index)"
            :title="item.cardName"
            :description="`${item.product?.name} ${item.cardCount}次  有效期：${item.expireDate}天`"
            :note="`￥${item.totalPrice}`"
            hover
          ></t-cell>
        </block>
        <block v-if="cardList.length">
          <text class="someTip">长按可编辑</text>
        </block>
      </t-tab-panel>
      
      <t-tab-panel label="打折卡" value="1">
        <block v-for="(item, index) in cardList2" :key="item._id">
          <t-cell 
            @click="choseThisCard(item, 2, index)"
            @longpress="handleLongPress(item, 2, index)"
            :title="item.cardName"
            :description="`${item.discount}折   有效期：${item.expireDate}天`"
            :note="`￥${item.totalPrice}`"
            hover
          ></t-cell>
        </block>
        <block v-if="cardList2.length">
          <text class="someTip">长按可编辑</text>
        </block>
      </t-tab-panel>
    </t-tabs>

    <bottom-box>
      <t-button type="primary" size="medium" @click="addNewCard">新增</t-button>
    </bottom-box>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import navBack  from '@/components/nav-back.vue'
// 路由实例
const router = useRouter()

// 响应式数据
const activeIndex = ref('0')
const cardList = ref([])
const cardList2 = ref([])

// 标签页切换
const onTabsChange = (value) => {
  activeIndex.value = value
  loadCardList()
}

// 选择卡片
const choseThisCard = (item, type, index) => {
  console.log('选择卡片:', item, type, index)
  // 处理选择卡片逻辑
}

// 长按卡片
const handleLongPress = (item, type, index) => {
  console.log('长按卡片:', item, type, index)
  // 处理长按编辑逻辑
}

// 新增卡片
const addNewCard = () => {
  // 跳转到新增卡片页面
  router.push('/cardAdd')
}

// 加载卡片列表
const loadCardList = async () => {
  try {
    if (activeIndex.value === '0') {
      // 加载次卡列表
      // cardList.value = await api.getCardList(1)
    } else {
      // 加载打折卡列表
      // cardList2.value = await api.getCardList(2)
    }
  } catch (error) {
    console.error('加载卡片列表失败:', error)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  loadCardList()
})
</script>

<style scoped>
 
.someTip {
  display: block;
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 24px;
}

/* 底部按钮容器样式 */
:deep(.bottom-box) {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 -2rpx 10rpx rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
</style>


